import React, { useState, useEffect } from 'react';
import { addClass, removeClass } from 'utils/index';
import StorageService from 'services/StorageService';
import Link from 'components/Link';
import appLogo from 'images/app-logo.png';
import PubSub from 'services/PubSub';
import style from './style.scss';//NOSONAR

let actions = [];
const appUrl = 'https://jumboapp.page.link/?link=https://www.jumbo.cl/login&apn=com.cencosud.cl.jumboahora&isi=1450934350&ibi=com.cencosud.jumboahora.cl&efr=1';

const AppDownload = ({sticky}) => {
    const [showNotification, setShowNotification] = useState(true);

    useEffect(() => {
        actions.push(PubSub.register('mobile_app', removeAppNotification));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const removeAppNotification = () => {
        removeClass(document.body, (sticky ? 'body-app-notification' : 'body-app-notification-sticky'));
        setTimeout(()=> {
            setShowNotification(false);
        },400)
        StorageService.setItem('app_download', true);
    }

    useEffect(() => {


        verifyNotification();
    });

    const verifyNotification = () => {
        const appDownload = JSON.parse(StorageService.getItem('app_download') || false) ;

        if(showNotification && (!appDownload)) {
            addClass(document.body, (sticky ? 'body-app-notification' : 'body-app-notification-sticky'));
            removeClass(document.body, (!sticky ? 'body-app-notification' : 'body-app-notification-sticky'));
            setShowNotification(true);

        } else {
            removeClass(document.body, (!sticky ? 'body-app-notification' : 'body-app-notification-sticky'));
            PubSub.dispatch('toggle_preheader', { state: false })
            setShowNotification(false);
        }
    }

    return <>
        {showNotification && <div className={'app-download'}>
            <div className={'app-download-wrap'}>
                <img src={appLogo} width={50} className={'app-image'}/>
                <div className={'info-wrap'}>
                    <div className={'text-wrap'}>
                        <strong>¡Descarga la App!</strong><span>Y descubre productos con despacho gratis</span>
                    </div>
                    <Link to={appUrl} target={'_blank'}>Descargar</Link>
                </div>
                <button className={'new-modal-close jumbo-icon-new-close'}  onClick={() => removeAppNotification()} />
            </div>
        </div> }
    </>
}

export default AppDownload;
